import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CustomFieldState } from './storeDataStateType';

const initialState: CustomFieldState = {
  customerCustomFields: [],
  customFieldApiResponse: [],
};

const customFieldsDataSlice = createSlice({
  name: "CustomFields",
  initialState: initialState,
  reducers: {
    setCustomerCustomFields: (
      state,
      action: PayloadAction<CustomFieldState['customerCustomFields']>
    ) => {
      state.customerCustomFields = action.payload
      return state;
    },
    setCustomFieldApiResponse: (
      state,
      action: PayloadAction<CustomFieldState['customFieldApiResponse']>
    ) => {
      state.customFieldApiResponse = action.payload;
      return state;
    }
  },
});

export const customFieldsDataAction = customFieldsDataSlice.actions;
export default customFieldsDataSlice;
